var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurMissionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 4.66667H32.6667V2.33333C32.6667 1.05 31.6167 0 30.3333 0H11.6667C10.3833 0 9.33333 1.05 9.33333 2.33333V4.66667H4.66667C2.1 4.66667 0 6.76667 0 9.33333V11.6667C0 17.6167 4.48 22.47 10.2433 23.1933C11.7133 26.6933 14.8633 29.33 18.6667 30.1V37.3333H11.6667C10.3833 37.3333 9.33333 38.3833 9.33333 39.6667C9.33333 40.95 10.3833 42 11.6667 42H30.3333C31.6167 42 32.6667 40.95 32.6667 39.6667C32.6667 38.3833 31.6167 37.3333 30.3333 37.3333H23.3333V30.1C27.1367 29.33 30.2867 26.6933 31.7567 23.1933C37.52 22.47 42 17.6167 42 11.6667V9.33333C42 6.76667 39.9 4.66667 37.3333 4.66667ZM4.66667 11.6667V9.33333H9.33333V18.2467C6.62667 17.2667 4.66667 14.7 4.66667 11.6667ZM37.3333 11.6667C37.3333 14.7 35.3733 17.2667 32.6667 18.2467V9.33333H37.3333V11.6667Z",
    fill: "#007ECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurMissionIcon);
export default __webpack_public_path__ + "static/media/OurMissionIcon.66a4feee28e4cfa51643e26339b3f78a.svg";
export { ForwardRef as ReactComponent };